import { Button } from "@/components/ui/button";
import { ChevronDown, Home, Plus } from "lucide-react";

const PLACEHOLDER_CHANNEL_COUNT = 10;


const ChannelRowSkeleton: React.FC = () => {
    const levelPadding = `${8 + 0 * 20}px`;
  
    return (
      <div className="relative">
        <div className="flex items-center relative">
          {/* spacer where the chevron button would be for items without children */}
          <div className="w-5" style={{ marginLeft: levelPadding }} />
  
          <div
            className="flex-1 relative h-9"
            style={{ paddingLeft: "4px" }}
          >
            <span className="block h-full w-full rounded-md bg-muted-foreground/20 animate-pulse" />
          </div>
        </div>
      </div>
    );
};

export const WorkspaceSidebarLoading = () => {
    return (
		<div className="flex h-full flex-col relative overflow-auto">
			{/* Overview Button - Show for Home and other sections */}
			<div className="border-border border-b">
				<Button
					variant="ghost"
					className="flex w-full items-center justify-start gap-3 p-4 text-left hover:bg-accent hover:text-accent-foreground"
				>
					<Home size={16} className="text-muted-foreground"/>
					<span className="font-medium h-4 w-32 rounded bg-muted-foreground/20 animate-pulse" />
				</Button>
			</div>

			{/* Public Section */}
			<div className="border-border border-b">
				<div className="flex w-full items-center justify-between gap-2 bg-muted/30 px-4 py-2">
					<div className="flex flex-1 items-center gap-2">
                        <ChevronDown size={14} className="text-muted-foreground"/>
						<div className="font-medium text-muted-foreground text-sm">Public</div>
					</div>
                    <Plus size={18} className="text-muted-foreground"/>
				</div>

                <div className="flex flex-col p-2 transition-all duration-200">
                    {Array.from({ length: PLACEHOLDER_CHANNEL_COUNT }).map((_, i) => (
                        <ChannelRowSkeleton key={`public-skel-${i}`} />
                    ))}
                </div>
			</div>

			{/* Private Section */}
			<div className="border-border border-b">
				<div className="flex w-full items-center justify-between gap-2 bg-muted/30 px-4 py-2">
                 <div className="flex flex-1 items-center gap-2">
                        <ChevronDown size={14} className="text-muted-foreground"/>
						<div className="font-medium text-muted-foreground text-sm">Private</div>
					</div>
                    <Plus size={18} className="text-muted-foreground"/>
				</div>
					<div className="flex flex-col p-2 transition-all duration-200">
                        {Array.from({ length: PLACEHOLDER_CHANNEL_COUNT }).map((_, i) => (
                            <ChannelRowSkeleton key={`private-skel-${i}`} />
                        ))}
					</div>
			</div>
		</div>
	);
}